<template>
  <div
    ref="modal"
    class="modal fade"
    :class="{ show: active, 'd-block': active }"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Form Data {{ action }} Checklist P2H</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            v-on:click="$emit('closeModal')"
            aria-label="btn-close"
          ></button>
        </div>

        <form class="forms-sample" method="POST" @submit.prevent="submitData">
          <div class="modal-body" style="max-height: 45vh; overflow-y: auto">
            <div class="row">
              <!-- Kolom 1 -->
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Job External ID</label>
                  <p style="font-weight: bold">{{ forms.job_external }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Customer</label>
                  <p style="font-weight: bold">{{ forms.company?.name }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Branch</label>
                  <p style="font-weight: bold">{{ forms.branch_name }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Payable</label>
                  <p style="font-weight: bold">
                    {{ formatNumber(forms.payable) }}
                  </p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Vehicle No</label>
                  <p style="font-weight: bold">{{ forms.vehicle_no }}</p>
                </div>
              </div>

              <!-- Kolom 2 -->
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Type Truck</label>
                  <p style="font-weight: bold">{{ forms.type_truck }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">NMK Driver</label>
                  <p style="font-weight: bold">{{ forms.driver_id }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Load Id</label>
                  <p style="font-weight: bold">{{ forms.load_id }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Shipwith Ref</label>
                  <p style="font-weight: bold">{{ forms.shipwith_ref }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Pick Plan</label>
                  <p style="font-weight: bold">{{ forms.pick_plan }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Pick Name</label>
                  <p style="font-weight: bold">{{ forms.pick_name }}</p>
                </div>
              </div>

              <!-- Kolom 3 -->
              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Dest Plan</label>
                  <p style="font-weight: bold">{{ forms.dest_plan }}</p>
                </div>
                <div class="mb-3">
                  <label class="form-label">Dest Name</label>
                  <p style="font-weight: bold">{{ forms.dest_name }}</p>
                </div>

                <div class="mb-3" v-if="action == 'Edit' && btn_submit">
                  <label class="form-label">P2H Status</label>
                  <div>
                    <div class="form-check form-check-inline">
                      <input
                        :disabled="true"
                        class="form-check-input"
                        type="radio"
                        v-model="forms.p2h_checklist_result"
                        id="valid"
                        value="VALID"
                      />
                      <label class="form-check-label" for="valid">VALID</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        :disabled="true"
                        class="form-check-input"
                        type="radio"
                        v-model="forms.p2h_checklist_result"
                        id="invalid"
                        value="INVALID"
                      />
                      <label class="form-check-label" for="invalid"
                        >INVALID</label
                      >
                    </div>
                  </div>
                </div>

                <div class="mb-3" v-if="action == 'Detail'">
                  <label class="form-label">P2H Status</label>
                  <input
                    type="text"
                    class="form-control"
                    readonly
                    v-model="forms.p2h_checklist_result"
                  />
                </div>

                <div class="mb-3">
                  <label class="form-label">UJO Status</label>
                  <input
                    type="text"
                    class="form-control"
                    readonly
                    v-model="forms.p2h_approval"
                  />
                </div>

                <div class="mb-3">
                  <label class="form-label">Accept Time</label>
                  <p style="font-weight: bold">
                    {{ forms.mload != null ? forms.mload.accept_time : "" }}
                  </p>
                </div>

                <div class="mb-3">
                  <label class="form-label">Temuan</label>
                  <textarea
                    :disabled="action == 'Detail'"
                    class="form-control"
                    v-model="forms.p2h_temuan"
                  ></textarea>
                </div>

                <div class="mb-3">
                  <label class="form-label">Confirm Field Man</label>
                  <textarea
                    :disabled="action == 'Detail'"
                    class="form-control"
                    v-model="forms.p2h_fieldman_confirm"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <div
            style="
              padding: 1rem;
              border-top: 1px solid #dee2e6;
              max-height: 30vh;
              overflow-y: auto;
            "
          >
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Page</th>
                  <th>Order</th>
                  <th class="wrap-text">Question</th>
                  <th>Control Type</th>
                  <th>Answer</th>
                  <th v-if="btn_submit">Outcome</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="forms && forms.qna && forms.qna.length">
                  <tr v-for="(item, index) in forms.qna" :key="index">
                    <td>{{ item.page }}</td>
                    <td>{{ item.order }}</td>
                    <td class="wrap-text">{{ item.question }}</td>
                    <td>{{ item.control_type }}</td>
                    <td>
                      <span v-if="item.control_type == 'photo'">
                        <img
                          class="imageAvatar"
                          :src="item.answer"
                          @click="showImage(item.answer)"
                        />
                      </span>

                      <span v-else-if="item.control_type == 'tire'"
                        >{{ item.value }}. {{ item.answer }}</span
                      >
                      <span v-else>{{ item.answer }}</span>
                    </td>
                    <td v-if="btn_submit">
                      <span v-if="action == 'Edit'">
                        <span v-if="item.outcome_detail === 'WAITING'">
                          <span
                            @click="
                              submitBtn(item.m_p2h_answer_detail_id, 'APPROVED')
                            "
                            class="btn btn-success btn-sm"
                            style="margin-right: 2px"
                          >
                            <i class="mdi mdi-check"></i>
                          </span>
                          <span
                            @click="
                              submitBtn(item.m_p2h_answer_detail_id, 'REJECTED')
                            "
                            class="btn btn-danger btn-sm"
                          >
                            <i class="mdi mdi-close"></i>
                          </span>
                        </span>

                        <span v-if="item.outcome_detail === 'APPROVED'">
                          <span
                            @click="
                              submitBtn(item.m_p2h_answer_detail_id, 'REJECTED')
                            "
                            class="btn btn-danger btn-sm"
                          >
                            <i class="mdi mdi-close"></i>
                          </span>
                          {{ item.outcome_detail }}
                        </span>

                        <span v-if="item.outcome_detail === 'REJECTED'">
                          <span
                            @click="
                              submitBtn(item.m_p2h_answer_detail_id, 'APPROVED')
                            "
                            class="btn btn-success btn-sm"
                          >
                            <i class="mdi mdi-check"></i>
                          </span>
                          {{ item.outcome_detail }}
                        </span>
                      </span>
                      <span v-else>
                        {{ item.outcome_detail }}
                      </span>
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="6">No Data</td>
                </tr>
                <!-- Jika tidak ada data -->
              </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="$emit('closeModal')"
            >
              Cancel
            </button>

            <div v-if="isLoading" class="d-flex align-items-center">
              <div
                class="spinner-border ms-auto"
                role="status"
                aria-hidden="true"
              ></div>
              <strong>Loading...</strong>
            </div>
            <span v-if="btn_submit">
              <button
                v-if="!isLoading && action == 'Edit' && isQnaAvailable"
                class="btn btn-primary"
                type="submit"
              >
                Submit
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";

//   import DateRangePicker from "vue2-daterange-picker";
//   import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import moment from "moment";
//import CurrencyInput from '@/components/_partials/inputCurrency.vue';
export default {
  components: {
    //CurrencyInput
    //DateRangePicker
    // DateRangePicker
  },
  name: "ModalFormApprove",
  emits: ["closeModal"],

  props: {
    showModal: Boolean,
    data: null,
    url: null,
    action: null,
  },
  computed: {
    isQnaAvailable() {
      const available = this.modalQna.length > 0;
      //console.log("isQnaAvailable:", available, " | modalQna:", this.modalQna);
      return available;
    },
  },
  watch: {
    showModal: {
      handler(newVal) {
        //const today = new Date();

        if (this.data) {
          //this.forms=[];
          this.active = newVal;
          this.loadData(this.data.load_id);

          if (this.data.qna) {
            this.modalQna = JSON.parse(JSON.stringify(this.data.qna));
            //console.log("modalQna loaded:", this.modalQna);
          }

          if (this.action == "Edit") {
            this.forms.p2h_approval = "APPROVED";
          }
        }

        // this.forms.payable = this.formatNumber(this.forms.payable);
        // console.log(this.forms.payable);
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() + 1);
    const endDate = new Date();

    return {
      modalQna: [],
      selectApprove: "",
      hiddenDownload: true,
      tanggal: {
        startDate,
        endDate,
      },
      btn_submit: true,

      minDate: null,
      maxDate: null,

      isLoading: false,
      active: this.showModal,
      forms: [],
      locale: {
        format: "dd mmm yyyy",
      },
      return_date: [],
      delivery_date: [],
      equipment_name: [],
      fetchEquipmentName: [],
      hiddenDate: false,
    };
  },
  methods: {
    handleChange() {
      if (this.selectApprove == "LATER") {
        this.hiddenDate = true;
      } else {
        this.hiddenDate = false;
      }
    },
    resetForm() {
      this.forms = [];
    },

    isInvalidDate(date) {
      // Ambil hari ini
      //console.log(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Tentukan H + 1
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      // Nonaktifkan tanggal setelah H + 1
      return new Date(date) > tomorrow;
    },

    showImage(imageUrl) {
      this.$swal({
        title: "Preview Image",
        imageUrl: imageUrl,
        imageAlt: "Answer Image",
        imageWidth: "80%", // biar responsive
        imageHeight: "auto",
        showCloseButton: true,
        width: "50vw", // popup lebih besar
        customClass: {
          image: "swal2-large-image",
        },
      });
    },

    formatNumber(value) {
      //console.log(value);
      return parseInt(value).toLocaleString();
    },

    downloadExcel(excel) {
      this.isLoading = true;
      const baseURI = `${this.$settings.endPoint}rm-ujo-master/approve-all-next-step`;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .post(
          baseURI,
          {
            excel: excel,
          },
          {
            responseType: "blob",
            timeout: 3600000,
          }
        )
        .then((response) => {
          this.isLoading = false;

          // Membuat URL untuk file yang akan diunduh
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();

          // Emit event untuk menutup modal
          this.$emit("closeModal");
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    submitData_v1() {
      this.isLoading = true;
      const baseURI =
        `${this.$settings.endPoint}/control-tower/transport-order-header/p2h-checklist-update/` +
        this.data.load_id;

      return this.$http
        .post(
          baseURI,
          {
            p2h_checklist_result: this.forms.p2h_checklist_result,
            p2h_approval: this.forms.p2h_approval,
            p2h_temuan: this.forms.p2h_temuan,
            p2h_fieldman_confirm: this.forms.p2h_fieldman_confirm,
            qna: this.forms.qna,
          },
          {
            timeout: 3600000,
          }
        )
        .then((response) => {
          this.isLoading = false;

          if (response.data.status === 200) {
            this.$emit("closeModal");
            //this.downloadExcel('yes');
            this.loadSuccess("Data has been Saved");
          } else {
            this.loadError(response.data.messages);
          }
          // Emit event untuk menutup modal
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            }
          }
        });
    },

    async submitData() {
      console.log(this.forms.p2h_temuan+'disini temuan');
      this.isLoading = true;
      this.btn_submit = false;
      console.log(this.btn_submit+'#ini keempat');
        var p2h_temuan=this.forms.p2h_temuan;
        var p2h_fieldman_confirm=this.forms.p2h_fieldman_confirm;
      try {
        // 1️⃣ AMBIL DATA TERBARU
        await this.loadData(this.data.load_id);

        // Ambil seluruh status
        const statuses = this.forms.qna.map((item) => item.outcome_detail);
        console.log(statuses+'ini statuses');
        const allApproved = statuses.every((s) => s === "APPROVED");
        const hasRejected = statuses.some((s) => s === "REJECTED");
        const hasWaiting = statuses.some(
          (s) => s !== "APPROVED" && s !== "REJECTED"
        );

        // =======================
        // 2️⃣ LOGIKA UTAMA
        // =======================
        console.log(this.forms.p2h_temuan+'disini temuan');
        if (hasWaiting) {
          // Munculkan pesan dan hentikan proses submit
          this.isLoading = false;
          this.btn_submit = true;
          this.$swal({
            icon: "warning",
            title: "Cek kembali jawaban Anda",
            text: "Masih ada checklist yang belum disetujui atau ditolak.",
          });
          return; // STOP
        }

        if (allApproved) {
          this.forms.p2h_checklist_result = "VALID";
        } else if (hasRejected) {
          this.forms.p2h_checklist_result = "INVALID";
        }

       
        // 3️⃣ KIRIM KE API
        const baseURI =
          `${this.$settings.endPoint}/control-tower/transport-order-header/p2h-checklist-update/` +
          this.data.load_id;

        const response = await this.$http.post(
          baseURI,
          {
            p2h_checklist_result: this.forms.p2h_checklist_result,
            p2h_approval: this.forms.p2h_approval,
            p2h_temuan: p2h_temuan,
            p2h_fieldman_confirm: p2h_fieldman_confirm,
            qna: this.forms.qna,
          },
          { timeout: 3600000 }
        );

        this.isLoading = false;

        if (response.data.status === 200) {
          this.$emit("closeModal");
          this.$emit("refresh");
          this.loadSuccess("Data has been Saved");
        } else {
          this.btn_submit = true;
          this.loadError(response.data.messages);
        }
      } catch (error) {
        this.isLoading = false;
        this.btn_submit = true;

        if (error.code == "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else {
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        }
      }
    },

    submitBtn(id, outcome) {
      this.isLoading = true;

      const baseURI = `${this.$settings.endPoint}/control-tower/transport-order-header/p2h-checklist-update-outcome/${id}?outcome_detail=${outcome}`;

      return this.$http
        .post(
          baseURI,
          {},
          {
            timeout: 3600000,
          }
        )
        .then((response) => {
          this.isLoading = false;

          if (response.data.status === 200) {
            //this.downloadExcel('yes');
            this.loadData(this.data.load_id);
          } else {
            this.loadError(response.data.messages);
          }
          // Emit event untuk menutup modal
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    loadData(load_id) {
      this.isLoading = true;
      console.log(this.btn_submit+'#ini pertama');
      //const baseURI = `${this.$settings.endPoint}/control-tower/transport-order-header/p2h-checklist-detail/`transport_order_header_id;
      const baseURI = `${this.$settings.endPoint}/control-tower/transport-order-header/p2h-checklist-detail/${load_id}`;
      return this.$http
        .get(baseURI, {
          timeout: 3600000,
        })
        .then((response) => {
          this.isLoading = false;

          //console.log("=== RESPONSE DATA ===");
          //console.log(JSON.stringify(response.data.datas, null, 2));

          this.forms = response.data.datas;

          this.modalQna = Array.isArray(this.forms.qna) ? this.forms.qna : [];

          if (this.forms.payable == null) {
            this.forms.payable = 0;
          }
          console.log(this.forms.p2h_checklist_result+'#ini p2h_checlist_result'+this.forms.p2h_checklist_result);
          console.log(this.forms.p2h_approval+'#ini p2h_checlist_result'+this.forms.p2h_checklist_result);
          if (
            this.forms.p2h_checklist_result == "VALID" &&
            this.forms.p2h_approval == "APPROVED"
          ) {
            this.btn_submit = false;
          }else{
             this.btn_submit = true;
          }

          
          console.log(this.btn_submit+'#ini kedua');
          this.forms.qna = this.forms.qna.sort((a, b) => {
            // sort berdasarkan page dulu
            if (a.page !== b.page) {
              return a.page - b.page;
            }
            // kalau page sama, sort berdasarkan order
            if (a.order !== b.order) {
              return a.order - b.order;
            }
            // kalau control_type = tire, sort lagi berdasarkan value
            if (a.control_type === "tire" && b.control_type === "tire") {
              // asumsikan value berupa angka, kalau string gunakan localeCompare
              return parseInt(a.value) - parseInt(b.value);
            }
            return 0;
          });

          // Emit event untuk menutup modal
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    resultError(data) {
      var html = "";
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          html += objectData[y] + "<br>";
        }
      }

      this.loadError(html);
    },

    loadError(pesan) {
      this.$swal({
        backdrop: true,
        title: "Warning",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.isLoading = false;
        }
      });
    },

    loadSuccess(pesan) {
      this.$swal({
        backdrop: true,
        title: "Success",
        html: pesan,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.isLoading = false;
        }
      });
    },
  },
  created: function () {
    //this.loadDriver();
  },
  mounted() {
    //tail(this.data);
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}

.imageAvatar {
  height: 200px !important;
  width: 200px !important;
  border-radius: 0% !important;
}

.wrap-text {
  max-width: 200px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}
</style>